<abc-popup
  #notificationPopup
  id="notificationPopup details-container"
  class="notification-popup"
  fxLayout="column"
  fxLayoutAlign="center center"
  shadingColor="rgba(0,0,0,0)"
  [width]="'350px'"
  [height]="'auto'"
  [title]="dataService.res('notification')"
  [showCloseButton]="true"
  [hideOnOutsideClick]="true"
  [resizeEnabled]="false"
  (onContentReady)="onPopupShown($event)"
>
  <div>
    <dxo-position my="top" at="top" of="#notification"> </dxo-position>
    <div
      fxLayout="column"
      class="notification-container"
      [attr.fxLayoutGap]="unreadNotifications().length > 1 ? '10px' : null"
    >
      @if (unreadNotifications().length > 0) {
        <div class="row">
          <div class="title" fxLayout="row">
            <span
              [innerHTML]="
                formatMessage(
                  'notification-newNotifications',
                  unreadNotifications().length
                )
              "
            ></span>
          </div>
        </div>
      }

      <div
        class="notification-list"
        [style.filter]="showLoader ? 'blur(0.2rem)' : 'blur(0)'"
      >
        @if (unreadNotifications().length > 0) {
          @for (notification of unreadNotifications(); track notification) {
            <div
              fxLayout="column"
              class="notification-item"
              (click)="redirectToDetails(notification)"
            >
              <div fxLayout="column" class="notification-content">
                <div
                  fxLayout="row"
                  fxLayoutAlign=" center"
                  [fxLayoutGap]="notification.Icon ? '5px' : '0px'"
                >
                  @if (notification.Icon) {
                    <span [ngClass]="notification.Icon"></span>
                  }
                  <span
                    class="notification-comment"
                    [innerHTML]="notification.Comment"
                  ></span>
                </div>
              </div>
              <div class="notification-date">
                {{ notification?.SysDateTimeInsert | Date: true }}
              </div>
            </div>
          }
        } @else {
          <div class="no-notification-message">
            {{ dataService.res("notification-noNotification") }}
          </div>
        }
      </div>

      <div
        class="notification-footer"
        fxLayout="row"
        fxLayoutAlign="end center"
      >
        @if (unreadNotifications().length > 0) {
          <abc-button
            class="submit-button"
            [text]="dataService.res('read')"
            (onClick)="onMarkAllAsRead()"
          ></abc-button>
        }
        <abc-button
          class="submit-button"
          [text]="dataService.res('notification')"
          (onClick)="onGoToNotifications()"
        ></abc-button>
      </div>
    </div>
  </div>
</abc-popup>

<confirmation-popup
  #markAllReadConfirmPopup
  [title]="dataService.res('confirm')"
  [message]="
    formatMessage(
      'notification-areYouSureYouWantToMarkNotification(s)AsRead?',
      unreadNotifications().length.toString()
    )
  "
  [primaryBtnText]="dataService.res('yes')"
  [secondaryBtnText]="dataService.res('no')"
>
</confirmation-popup>
